import { useCallback } from 'react';
import { get } from '../api';

interface School {
  id: string;
  name: string;
  address: string;
  postalCode: string;
  city: string;
  schoolType: string;
}

export const useSchoolNameEndpoint = () => {
  const fetchSchoolNames = useCallback(async (query: string): Promise<School[]> => {
    const response = await get(`/schools?Query=${query}`, { ignoreAuthentication: true });
    const { data } = await response.json();
    return data ?? []; // Default to an empty array if data is undefined
  }, []);

  return { fetchSchoolNames };
};
